import { render, staticRenderFns } from "./FrontPage.vue?vue&type=template&id=ef596e22&scoped=true"
import script from "./FrontPage.vue?vue&type=script&lang=js"
export * from "./FrontPage.vue?vue&type=script&lang=js"
import style0 from "./FrontPage.vue?vue&type=style&index=0&id=ef596e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef596e22",
  null
  
)

export default component.exports